import React, { Component, Fragment } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Row, Col, Input, Table, Label, Form } from 'reactstrap';
import '../Admin/Admin.css';

class TimeTrackingContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.formatDateForInput(new Date().toISOString()),
            days: '',
            showWeekends: false
        };
    }

    componentDidMount() {
        this.props.log('TimeTrackingContainer.js/componentDidMount');
        this.getTimeTracking();
    }

    getTimeTracking = () => {
        this.props.log('TimeTrackingContainer.js/getServices');
        fetch('/api/time-tracking/' + this.state.date, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        timeTracking: results.data,
                        days: results.days,
                        isLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load time tracking.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditTimeTracking = (serviceId, parent = false) => {
        this.props.log('TimeTrackingContainer.js/onEditTimeTracking (serviceId,parent)', serviceId, parent);
    }

    onDeleteTimeTracking = (timeTrackingId, arr, data) => {
        this.props.log('TimeTrackingContainer.js/onDeleteTimeTracking (timeTrackingId, arr, data)', timeTrackingId, arr, data);
        data[arr[1]][arr[2]] = null;
        fetch('/api/time-tracking/' + timeTrackingId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify({
                user: this.props.user
            }),
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        timeTracking: data,
                    });
                    // this.props.addToast('Time deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete time.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeTimeTracking = (e) => {
        this.props.log('TimeTrackingContainer.js/onChangeTimeTracking (e)', e, e.target.name, e.target.value);
        const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
        const arr = e.target.name.split('_');
        let data = [...this.state.timeTracking];
        if (data[arr[1]][arr[2]] == null) data[arr[1]][arr[2]] = {};
        data[arr[1]][arr[2]][arr[0]] = e.target.value;
        if ((data[arr[1]][arr[2]].start === '' || data[arr[1]][arr[2]].start == null) && (data[arr[1]][arr[2]].status === '' || data[arr[1]][arr[2]].status == null)) {
            this.onDeleteTimeTracking(data[arr[1]][arr[2]].id, arr, data);
        } else {
            if (arr[3] > -1) {
                fetch('/api/time-tracking/' + arr[3], {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken
                    },
                    body: JSON.stringify({
                        employeeId: data[arr[1]][0].employeeId,
                        date: this.state.days[days[parseInt(arr[2]) - 1]],
                        startTime: data[arr[1]][arr[2]].start !== '' ? data[arr[1]][arr[2]].start : null,
                        endTime: data[arr[1]][arr[2]].end !== '' ? data[arr[1]][arr[2]].end : null,
                        status: data[arr[1]][arr[2]].status !== '' ? data[arr[1]][arr[2]].status : null,
                        user: this.props.user
                    }),
                }).then(results => results.json())
                    .then(results => {
                        if (results.success) {
                            this.setState({
                                timeTracking: data,
                            });
                        } else {
                            this.props.addToast('Unable to save time tracking!', 5, 'danger');
                        }
                    })
                    .catch(() => {
                        this.props.addToast('An error has occurred.', 5, 'danger');
                    })
            } else {
                fetch('/api/time-tracking/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.props.clientToken
                    },
                    body: JSON.stringify({
                        employeeId: data[arr[1]][0].employeeId,
                        date: this.state.days[days[parseInt(arr[2]) - 1]],
                        startTime: data[arr[1]][arr[2]].start,
                        endTime: data[arr[1]][arr[2]].end,
                        status: data[arr[1]][arr[2]].status,
                        user: this.props.user
                    }),
                }).then(results => results.json())
                    .then(results => {
                        if (results.success) {
                            data[arr[1]][arr[2]].id = results.data
                            this.setState({
                                timeTracking: data,
                            });
                        } else {
                            this.props.addToast('Unable to save time tracking.', 5, 'danger');
                        }
                    })
                    .catch(() => {
                        this.props.addToast('An error has occurred.', 5, 'danger');
                    })
            }
        }
    }

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10))//+'/'+parseInt(String(d).substring(0,4));
    }

    formatDateForInput = (d) => {
        return String(d).substring(0, 4) + '-' + (String(d).substring(5, 7)) + '-' + (String(d).substring(8, 10));
    }

    render() {
        this.props.info('TimeTrackingContainer.js/render');
        const daysArray = !this.state.showWeekends ? [2, 3, 4, 5, 6] : [1, 2, 3, 4, 5, 6, 7];
        return (
            (this.state.isLoaded) ?
                <>
                    <Row>
                        <Col md={12}>
                            <Form inline>
                                <Label>Week of: <Input className='ml-2' type="date" value={this.state.date} onChange={(e) => this.setState({ date: e.target.value }, () => this.getTimeTracking())} /></Label>
                                <Label className='ml-5'>Show Weekends? <Input className='ml-2' type="checkbox" checked={this.state.showWeekends} onChange={() => this.setState({ showWeekends: !this.state.showWeekends })} /></Label>
                            </Form>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col>
                            <div className="text-left position-absolute bg-white">
                                <Table>
                                    <thead>
                                        <tr><th className='border-right'>&nbsp;</th></tr>
                                        <tr><th className='border-right'>&nbsp;</th></tr>
                                    </thead>
                                    <tbody>
                                        {this.state.timeTracking.map(employee => (
                                            <tr key={employee[0].employeeId}>
                                                <td className="w-table-long border-right py-0"><Form inline>{employee[0].lastName}, {employee[0].firstName} <Input type="text" className="invisible w-1" /></Form></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="scrollH">
                                <Table>
                                    <thead>
                                        <tr>
                                            <th className='text-left' rowSpan={2}>Employee</th>
                                            {this.state.showWeekends && <th className='border-left' colSpan={2}>Sun. {this.formatDate(this.state.days.sunday)}</th>}
                                            <th className='border-left bg-light' colSpan={2}>Mon. {this.formatDate(this.state.days.monday)}</th>
                                            <th className='border-left' colSpan={2}>Tue. {this.formatDate(this.state.days.tuesday)}</th>
                                            <th className='border-left bg-light' colSpan={2}>Wed. {this.formatDate(this.state.days.wednesday)}</th>
                                            <th className='border-left' colSpan={2}>Thu. {this.formatDate(this.state.days.thursday)}</th>
                                            <th className='border-left bg-light' colSpan={2}>Fri. {this.formatDate(this.state.days.friday)}</th>
                                            {this.state.showWeekends && <th className='border-left' colSpan={2}>Sat. {this.formatDate(this.state.days.saturday)}</th>}
                                        </tr>
                                        <tr>
                                            {this.state.showWeekends && <><th className='border-left'>Start</th>
                                                <th>Status</th></>}
                                            <th className='border-left bg-light'>Start</th>
                                            <th className='bg-light'>Status</th>
                                            <th className='border-left'>Start</th>
                                            <th>Status</th>
                                            <th className='border-left bg-light'>Start</th>
                                            <th className='bg-light'>Status</th>
                                            <th className='border-left'>Start</th>
                                            <th>Status</th>
                                            <th className='border-left bg-light'>Start</th>
                                            <th className='bg-light'>Status</th>
                                            {this.state.showWeekends && <><th className='border-left'>Start</th>
                                                <th>Status</th></>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.timeTracking.map((employee, employeeIndex) => (
                                            <tr key={employeeIndex}>
                                                <td className="w-table-long py-1 text-left">{employee[0].lastName}, {employee[0].firstName}</td>
                                                {daysArray.map(index => (
                                                    <Fragment key={index}>
                                                        <td className={'border-left py-0 pl-2 pr-0 ' + (index % 2 === 0 ? "bg-light" : "")}>
                                                            <Input
                                                                type="time"
                                                                name={"start_" + employeeIndex + "_" + index + "_" + (employee[index] != null && employee[index].id != null ? employee[index].id : -1)}
                                                                value={employee[index] != null && employee[index].start != null ? employee[index].start : ''}
                                                                onChange={this.onChangeTimeTracking}
                                                            />
                                                        </td>
                                                        <td className={'py-0 pl-1 pr-2 ' + (index % 2 === 0 ? "bg-light" : "")}>
                                                            <Input
                                                                type="select"
                                                                name={"status_" + employeeIndex + "_" + index + "_" + (employee[index] != null && employee[index].id != null ? employee[index].id : -1)}
                                                                value={employee[index] != null && employee[index].status != null ? employee[index].status : ''}
                                                                onChange={this.onChangeTimeTracking}
                                                                className="noWidth"
                                                            >
                                                                <option></option>
                                                                <option>Personal</option>
                                                                <option>Vacation</option>
                                                                <option>Sick</option>
                                                                <option>Bereavement</option>
                                                                <option>Jury Duty</option>
                                                            </Input>
                                                            {/* <Input
                                                                type="time"
                                                                name={"end_" + employeeIndex + "_" + index + "_" + (employee[index] != null && employee[index].id != null ? employee[index].id : -1)}
                                                                value={employee[index] != null && employee[index].end != null ? employee[index].end : ''}
                                                                onChange={this.onChangeTimeTracking}
                                                            /> */}
                                                        </td>
                                                    </Fragment>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default TimeTrackingContainer;
